import React, { useEffect, useState, useContext } from 'react';
import { CSSTransition } from 'react-transition-group';
import Styled from 'styled-components';
import { fontQuicksand } from '../../common/mixins/mixin';
import { computePricingInfo, amountInLocalCurrency, melaDurationMap, subjectCodeMap } from '../../../../app/js_bytesize/templates/purchase/pricing-helper';
import { device, breakpoints } from '../../../../app/js/utils/responsive_utilities';
import { SemContext } from "../../context/SemContext";
import ProductPlan from './Plan';
import FilterTab from './FilterTab';
import PurchaseCta from './PurchaseCta';
import CreditCardsContainer from './CreditCardsContainer';
import { setEmail, setShowMorePlans} from "../../actions/actions"
import { GuestUserCreation } from "../../../../app/js/services/loggedout-api";
import { SaveCreditCardApi, SubscribeProductApi, SetGradeApi } from "../../../../app/js/services/parent-api"
import { durationListForSorting } from '../../../../app/js/utils/web-helper';
import MoneyBackStripe from './MoneyBackStripe';
import OnboardingAnimation from '../../common/animation/animation-components/OnboardingAnimation';
import Promo from './promo-page/Promo';
import { FormHeading } from '../../common/styled-components/styled-components';
import { DURATION_MAPPING } from './const';
import { getABTestValue } from '../../../../app/js/utils/ab-tests';

function Plans({
  products,
  activeFilterTab,
  filterTabList,
  filterTabHandler,
  productsBySubject,
  settings,
  sortedDurationList
}) {
  let { state, dispatch } = useContext(SemContext);
  const defaultPlan = state.settings && state.settings.default_plan;
  let DEFAULT_PLAN_DURATION =
    defaultPlan && sortedDurationList.includes(defaultPlan)
      ? defaultPlan
      : sortedDurationList[0];

  const [initialDuration, setInitialDuration] = useState(DEFAULT_PLAN_DURATION);
  const [selectedBox, selectedBoxHandler] = useState(products.get(initialDuration));
  const [selectedPlan, selectedPlanHandler] = useState({});
  const [selectedPlanName, setSelectedPlanName] = useState(DEFAULT_PLAN_DURATION);
  const [error, setError] = useState(null);
  const [savePercentage, setSavePercentage] = useState(null);
  const [percentOffAmount, setPercentOffAmount] = useState(null);
  const [showOnboardingAnimation, setShowOnboardingAnimation] = useState(false);
  
  let { properties = {}, access_duration } = selectedPlan;
  let { actualPrice = 0,
    discountedPrice = 0,
    percentOff = null } = Object.keys(selectedPlan).length ? computePricingInfo(selectedPlan, settings) : {};

  let showFilter = productsBySubject.has('mela');
  let subjectsLength = productsBySubject.size;
  const { showMorePlans = false } = state;
  const variant = localStorage.getItem("sem_variant") || state.variant;
  useEffect(() => {
    selectedBoxHandler(products.get(DEFAULT_PLAN_DURATION));
    setInitialDuration(DEFAULT_PLAN_DURATION);
    setSelectedPlanName(DEFAULT_PLAN_DURATION);
  }, [activeFilterTab])

  useEffect(() => {
    selectedBox.find((val) => {
      if (val.properties.title0 === selectedPlanName) {
        selectedPlanHandler(val);
      }
    })
  }, [selectedBox])

  const sortProducts = (products, duration, property) => {
    return products ? (products.get(duration) ? products.get(duration).sort((a, b) => a[property] - b[property]) : []) : []
  }

  useEffect(() => {
    if (products && sortedDurationList.length > 0 && Object.keys(selectedPlan).length) {
      const sortedProductsDuration = durationListForSorting.filter(val => products.has(val));
      const largestPlan = sortedProductsDuration.length ? sortProducts(products, sortedProductsDuration[0], "credit_count")[0] : selectedPlan;
      const smallestPlan = sortedProductsDuration.length ? sortProducts(products, sortedProductsDuration[sortedProductsDuration.length - 1], "credit_count")[0] : selectedPlan;
      const selectedProductPriceInfo = computePricingInfo(selectedPlan, settings);
      let comparedProduct = selectedProductPriceInfo;

      let largestProductPricingInfo = computePricingInfo(largestPlan, settings);
      const smallestPlanPricingInfo = computePricingInfo(smallestPlan, settings);
      if (selectedPlan.properties.title0 == largestPlan.properties.title0)
        comparedProduct = smallestPlanPricingInfo;

      if(comparedProduct.actualMonthlyPrice < largestProductPricingInfo.actualMonthlyPrice)
      {
        comparedProduct = smallestPlanPricingInfo;
        largestProductPricingInfo = selectedProductPriceInfo;
      }

      const savePercent = Math.abs(Math.floor(100 * (Number(comparedProduct.actualMonthlyPrice) - Number(largestProductPricingInfo.actualMonthlyPrice)) / Number(comparedProduct.actualMonthlyPrice)))
      setSavePercentage(savePercent);
      setPercentOffAmount(selectedProductPriceInfo.percentOff);
    }
  }, [selectedPlan]);

  useEffect(() => {
    if (showMorePlans) {
      trackAnalyticsEvent('Visited All Plans Page', {});
    }
  }, [showMorePlans])



  const updateInitialDuration = (event, val, doContinue) => {
    if (!(!doContinue && sortedDurationList.length > 1 && (val === sortedDurationList[1] || (subjectsLength > 1 && activeFilterTab.id !== "mela")))) {
      setSelectedPlanName(val);
      const showMorePlanResp = setShowMorePlans(false);
      dispatch(showMorePlanResp);
    } else {
      setInitialDuration(val);
      switchToYearlyPlan(true);
    }
  }

  const activePlanHandler = (val, plan) => {
    let mixpanelEventName = "Interacted Plan Purchase Combined Page"//showMorePlans ? 'Interacted All Plans Page' : 'Interacted Plan Purchase Combined Page';

    if (plan && plan.properties && plan.properties.payment_frequency === 'quarterly') {
      trackAnalyticsEvent("Interacted All Plans Page", { 'Interaction Details': "Clicked Quarterly", 'Clicked On': 'Quarterly' });
    } else {
      if (plan.properties.title0 === 'family') {
        trackAnalyticsEvent(mixpanelEventName, { 'Interaction Details': "Clicked Family Plan", 'Clicked On': 'Family Plan' });
      } else {
        trackAnalyticsEvent(mixpanelEventName, { 'Interaction Details': "Clicked Single Child Plan", 'Clicked On': 'Single Child Plan' });
      }
    }

    setInitialDuration(val);
    selectedBoxHandler(products.get(val));
    selectedPlanHandler(plan);
    setSelectedPlanName(plan.properties.title0);

  }

  const switchToYearlyPlan = (doContinue) => {

    if (doContinue) {
      trackAnalyticsEvent('Interacted All Plans Page', { 'Interaction Details': "Continue", 'Clicked On': 'Continue' })
      trackAnalyticsEvent('Interacted Plan Purchase Combined Page', { 'Interaction Details': "Continue", 'Clicked On': 'Continue' })

      return updateInitialDuration(null, initialDuration, doContinue);
    }
    else {
      trackAnalyticsEvent('Interacted All Plans Page', { 'Interaction Details': "Changed Plan", 'Clicked On': 'Changed Plan' })
    }

    if (subjectsLength > 1) {
      filterTabHandler(filterTabList[0]);
    }
    selectedBoxHandler(products.get(DEFAULT_PLAN_DURATION));
    setInitialDuration(DEFAULT_PLAN_DURATION);
    updateInitialDuration(null, DEFAULT_PLAN_DURATION, true);
  }
  const saveAndSubscribeProduct = (params) => {
    return new Promise(async (resolve, reject) => {
      let options = {};
      try {
        const saveCardResp = await SaveCreditCardApi(params, true);
        let subscribeData = { ...params } || {};
        const coupon = state.coupons && state.coupons[0];
        subscribeData["stripe_card_id"] = saveCardResp.stripe_card.stripe_id;
        options = {
          ...subscribeData['stripe_card_id'],
          product_id: selectedPlan.id,
          trial_days: state.settings.trial_days,
        };
        const campaign_code = localStorage.getItem("campaign_code");
        if(campaign_code){
          options['campaign_code'] = campaign_code;
        }
        if (coupon && coupon.stripe_id) {
          options['adc'] = coupon.stripe_id;
        }
        trackAnalyticsEvent("Credit Card Added - via Onboarding")
        trackAnalyticsEvent("Click Payment Button");
      }
      catch (err) {
        console.error(err);
        return reject(err);
      }

      try {
        const subscribeProductResp = await SubscribeProductApi(options, true)
        let eventObj = {
          'Product Name': subjectCodeMap[selectedPlan.properties.display_name],
          'Product Cost': amountInLocalCurrency(selectedPlan.amount, selectedPlan),
          'Product Duration': melaDurationMap[selectedPlan.access_duration],
          // [AI GENERATED CODE] Simplified: ELA is always enabled, so always use 'Mela 1.0'
          'Variation': 'Mela 1.0',
          'Flow': 'SEM Flow',
          'Landing Page': `landing_page_${variant}`
        }
        trackAnalyticsEvent("Product Purchased Frontend", eventObj)

        // [AI GENERATED CODE] Pass ltv_trial_value as ecomm_totalvalue to GTM
        const gtmEventData = subscribeProductResp?.ltv_trial_value ? { ecomm_totalvalue: subscribeProductResp.ltv_trial_value } : {};
        trackToGtm(window.dataLayer, 'Trial Start Web', 'Trial Start Web', gtmEventData);
        trackEventOnGA('Trial Start');
        trackToGtm(window.dataLayer, 'Trial Start', 'Trial Start');

        trackServerEventToFacebook('transaction');
        trackTransactionEventToGtm('transaction');
        return resolve("Success");

      }
      catch (err) {
        console.error(err);
        trackAnalyticsEvent("Stripe Error", {
          "Subscription Plan": selectedPlan.code,
          "message": err.error
        });
        return reject(err);
      }
    });
  }

  const paymentHandler = async (params = {}) => {
    dispatch(setEmail(params.email));
    localStorage.setItem("sem-email", params.email);

    try {
      const campaign_code = localStorage.getItem("campaign_code");
      //Creating Parent user by overriding user parameter
      const userCreation = await GuestUserCreation({
        user: {
          type: "parent",
          email: params.email
        },
        fromSemLandingPage: true,
        rejectWithErrorObject: true,
        // hideSpinner: true,
        variant: variant,
        ...(campaign_code != "undefined" && { source: campaign_code })
      })

      setShowOnboardingAnimation(true);

      const response = await Promise.all([SetGradeApi({
        grade_code: state.grade,
        student_id: null,
        onboarding: true,
        password_not_set: true,

      }, true), saveAndSubscribeProduct(params)])
      location.href = "/parent-dashboard/#set-password";
    }

    catch (err) {
      const errMsg = err && err.errors && err.errors[0] || "Something went wrong, please try again.";
      trackAnalyticsEvent("Promo Page Error Viewed", {"Landing Page Name" : variant, "Error Message" : errMsg})
      setShowOnboardingAnimation(false);
      setError(errMsg)
      console.error(err);
    }

  }
  const headerTitle = state.settings.plan_page_header_text || `SplashLearn ${settings.trailDays} days free trial`;
  const TrialUser = settings.trailDays ? true : false;
  return (
    <>
      {showOnboardingAnimation && <OnboardingAnimation isTrialUser={TrialUser}/>}
      { settings.showPromoPopup !== 'true' && (<Heading>{headerTitle}</Heading>) }
      { !settings.showMoneyBack && <MoneyBackContainer>
        <MoneyBackStripe hideTillTablet={true} bgColor='#212682' toolTipColor="#5659DD" fColor='#fff' iIconColor="#5659DD" textColor={true} />
      </MoneyBackContainer>}

      <CSSTransition in={subjectsLength > 1 && showMorePlans}
        timeout={300}
        classNames="filter-tab-anim"
      >
        <FilterTab activeFilterTab={activeFilterTab} filterTabList={filterTabList} filterTabHandler={filterTabHandler} showFilter={showFilter} subjectsLength={subjectsLength} />
      </CSSTransition>
      <CSSTransition in={subjectsLength > 1 && showMorePlans} timeout={200} classNames="tile-slide">
        <div className="product-plan-tile" >

          <ProductPlan
            products={products}
            activeFilterTab={activeFilterTab}
            initialDuration={initialDuration}
            activePlanHandler={activePlanHandler}
            selectedPlan={selectedPlan}
            selectedBox={selectedBox}
            settings={settings}
            properties={properties}
            subjectsLength={subjectsLength}
            sortedDurationList={sortedDurationList}
            savePercentage={savePercentage}
            percentOffAmount={percentOffAmount}

          />
        </div>
      </CSSTransition>

      {settings.withoutCC !== true && selectedPlan && <CSSTransition in={!showMorePlans} timeout={0} classNames="credit-slide" unmountOnExit mountOnEnter>
        <Wrapper>
          <CreditSectionHeading>Enter your payment details</CreditSectionHeading>
          {!percentOff && <>
            <SelectedPlanDetails>Unlimited access to {properties.display_name} at {amountInLocalCurrency(actualPrice, selectedPlan)} {settings.showZipOnPurchase ? '*' : ''} (billed {melaDurationMap[access_duration]}). Renewed automatically</SelectedPlanDetails>
            <SelectedPlanDetails>Cancel anytime</SelectedPlanDetails>
          </>  
          }
          {!!percentOff && <>
            <SelectedPlanDetails>Unlimited access to {properties.display_name} at {amountInLocalCurrency(discountedPrice, selectedPlan)} for 1st {DURATION_MAPPING[selectedPlan.display_name]}.</SelectedPlanDetails>
            <SelectedPlanDetails>Auto renews {melaDurationMap[access_duration] && melaDurationMap[access_duration].toLowerCase()} at {amountInLocalCurrency(actualPrice, selectedPlan)}. Cancel anytime.</SelectedPlanDetails>
          </>  
          }
          <CreditCardsContainer
            settings={settings}
            selectedPlan={selectedPlan}
            paymentHandler={paymentHandler}
            error={error}
            setError={setError}
          />

        </Wrapper>
      </CSSTransition>}

      {showMorePlans && <PurchaseCta settings={settings} clickHandler={updateInitialDuration} titleDuration={initialDuration}/>}
      {settings.withoutCC === true && settings.showPromoPage === true && <Promo selectedPlan={selectedPlan}/>}

    </>
  );
}

export default Plans;

export const Wrapper = Styled.div`
  form {
    margin: 0 auto;
  }
`;

export const CreditSectionHeading = Styled.h3`
  margin-top: 2rem;
  ${fontQuicksand(2, 2.6, 7)};
  @media ${device.PhoneLargeScreen} {
    margin-top: 2rem;
    ${fontQuicksand(1.4, 2, 7)};
  }
  @media ${device.Phone} {
    margin-top: 2rem;
    ${fontQuicksand(1.6, 2, 7)};
  }
  @media (min-width: ${breakpoints.lg}px) {
    margin: 3.2rem 0 0.8rem;
    ${fontQuicksand(1.6, 2, 7)};
  }
`;

export const SelectedPlanDetails = Styled.p`
  width: 45rem;
  margin: 0.4rem auto 0;
  ${fontQuicksand(1.4, 1.8, 5)};
  @media ${device.PhoneLargeScreen} {
    width: 90%;
    ${fontQuicksand(1.2, 1.6, 5)};
  }
  @media ${device.Phone} {
    width: 90%;
    ${fontQuicksand(1.1, 1.6, 5)};
  }
  @media (min-width: ${breakpoints.lg}px) {
    width: 100%;
    text-align: center;
    ${fontQuicksand(1.2, 1.6, 5)};
  }
`;

const Heading = Styled(FormHeading)`
@media (min-width: ${breakpoints.lg - 1}px) {
  ${fontQuicksand(3.2, 4, 7)};
}`

const MoneyBackContainer = Styled.div`
  margin: 0.8rem auto 3.1rem;
`